import script from "./SignupConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupConfirm.vue?vue&type=script&setup=true&lang=js"

import "./SignupConfirm.vue?vue&type=style&index=0&id=23922eb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23922eb4"]])

export default __exports__